import { render, staticRenderFns } from "./BatchSearch.vue?vue&type=template&id=3a5e24b1"
import script from "./BatchSearch.vue?vue&type=script&lang=js"
export * from "./BatchSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports